module.exports = __webpack_public_path__ + "static/supplierbg1-1eb5c98957d4eabc35f50940791314b8.jpg";